import React from "react";
import { Accordion, Badge, Col, ListGroup, Row } from "react-bootstrap";
import { AppLink } from "../../services/goTo.jsx";

function clean(text = "") {
  return text
    .replace(/<[^>]+>/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

function routeLabel(step) {

  if (shortName) {
    return name ? `${shortName} - ${name}` : shortName;
  }
  return "Bus";
}

function isIntercityRoute(step) {
  const agencies = step.transit?.line?.agencies;

  return Array.isArray(agencies)
    && agencies.some((agency) => agency?.name?.includes("Intercity"));
}

function WalkingDetails({ step }) {
  const substeps = Array.isArray(step.steps) ? step.steps : [];

  if (!substeps.length) {
    return null;
  }

  return (
    <ol className="walk-details mb-0 ps-3">
      {substeps.map((substep, index) => (
        <li key={index}>
          {clean(substep.instructions)}
          {substep.distance?.text && (
            <span className="text-muted"> — {substep.distance.text}</span>
          )}
        </li>
      ))}
    </ol>
  );
}

function TransitDetails({ step }) {
  if (step.travel_mode !== "TRANSIT" || !step.transit) {
    return null;
  }

  const shortName = step.transit?.line?.short_name || "";
  const name = step.transit?.line?.name || "";
  const showRouteLink = isIntercityRoute(step);

  return (
    <div className="ps-3">
      <div className="mb-2 d-flex align-items-center">
        <Badge className="route-number me-2">
          {shortName || "-"}
        </Badge>
        <strong>Route {shortName} - {name}</strong>{" "}

      </div>

      <Row className="mb-2">
        <Col>
          <p>
            <strong>
              Board at: {" "}
            </strong>
            {step.transit.departure_stop?.name}
          </p>
          <p><strong>
            Exit at: {" "}</strong>
            {step.transit.arrival_stop?.name}
          </p>

          <p>
            <strong>
              Departs at: {" "}
            </strong>
            {step.transit.departure_time?.text}
          </p>
          <p>
            <strong>
              Arrives at: {" "}
            </strong>
            {step.transit.arrival_time?.text}
          </p>
        </Col>
        {showRouteLink && (
          <Col xs={12} className="mt-2">
            <em>
              <AppLink
                to={`/plan-your-trip/routes/${shortName}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                View Route {shortName} schedule.
              </AppLink>
            </em>
          </Col>
        )}
      </Row>
    </div>
  );
}

function StepItem({ step, stepIndex }) {
  const isTransitStep = step.travel_mode === "TRANSIT";
  const hasWalkingDetails =
    !isTransitStep && Array.isArray(step.steps) && step.steps.length > 0;
  const [showWalkingDetails, setShowWalkingDetails] = React.useState(false);

  return (
    <ListGroup.Item className="p-0 border-0">
      <div className="mt-3 trip-instruction">
        {stepIndex + 1}. {clean(step.instructions)}
        {hasWalkingDetails && (
          <a
            href="#"
            className="ms-2"
            onClick={(event) => {
              event.preventDefault();
              setShowWalkingDetails((prev) => !prev);
            }}
            aria-expanded={showWalkingDetails}
            aria-label={showWalkingDetails ? "Hide walking details" : "Show walking details"}
          >
            ...
          </a>
        )}
      </div >
      <div className="ps-5">
        <div hidden={hasWalkingDetails && !showWalkingDetails}>
          <WalkingDetails step={step} />
        </div>
        <TransitDetails step={step} />
      </div>
    </ListGroup.Item >
  );
}

export default function TripResultItem({
  directions,
  selectedRouteIndex,
  onSelectRoute,
}) {
  if (!directions?.routes?.length) {
    return null;
  }


  return (
    <Accordion
      defaultActiveKey={null}
      onSelect={(key) => onSelectRoute(key === null ? null : Number(key))}
    >
      {directions.routes.map((route, routeIndex) => {
        const leg = route.legs?.[0];

        if (!leg) {
          return null;
        }

        const isOpen = selectedRouteIndex === routeIndex;
        const trip_routes = (Array.isArray(leg.steps) ? leg.steps : [])
          .filter((step) => step.travel_mode === "TRANSIT")
          .map((step) => step.transit?.line?.short_name)
          .filter(Boolean);

        return (
          <Accordion.Item
            key={routeIndex}
            eventKey={String(routeIndex)}
            className="my-3"
          >
            <Accordion.Header>
              <span className="d-flex align-items-center">
                <i
                  className={`fas ${isOpen ? "fa-chevron-up" : "fa-chevron-down"}`}
                  aria-hidden="true"
                />
                <span className="ms-2">
                  {trip_routes.length ? trip_routes.join(" > ") : `Option ${routeIndex + 1}`}
                </span>
              </span>

              <span className="ms-auto text-muted small">
                ({leg.duration?.text})
              </span>
            </Accordion.Header>

            <Accordion.Body className="px-2 py-3">
              <Row className="mb-3">
                <Col>
                  Depart at  {leg.departure_time?.text || " - "}
                </Col>

                <Col>
                  Arrive at  {leg.arrival_time?.text || " - "}
                </Col>
                {/*
                <Col>
                  Duration {leg.duration?.text}
                </Col>

                <Col>
                  Distance {leg.distance?.text}
                </Col> */}
              </Row>

              <ListGroup>
                {leg.steps.map((step, stepIndex) => (
                  <StepItem key={stepIndex} step={step} stepIndex={stepIndex} />
                ))}
              </ListGroup>
            </Accordion.Body>
          </Accordion.Item>
        );
      })}
    </Accordion>
  );
}
